export default __webpack_public_path__ + "static/media/arrow.03c44774.svg";